import { RichTextLink } from './RichTextLink'

export default RichTextLink
